import { computed, defineComponent, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import { store } from "./store/MailAddressChangeStore";
import { Log, Validator, presence, maxLength, email } from "~/extensions/utils";
import { useLoad } from "../password/composition/Load";
import { MsgBox } from "~/components/MsgBox";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { MailAddress } from "~/api/data/MailAddress";
import { myPageStore } from "~/store/MyPageStore";
import { commonStore } from "~/store/CommonStore";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { PageID } from "~/extensions/utils/DefineTypes";
const log = Log.create("PasswordChangePage");
// エラーメッセージ
const requiredErrorMessage = "入力してください。";
const emailRegExpErrorMessage = "有効なメールアドレスを入力してください。";
const constraints = {
    mailAddress: {
        presence: presence(false, requiredErrorMessage),
        length: maxLength(50),
        email: email({ message: emailRegExpErrorMessage })
    }
};
export default defineComponent({
    name: "MailAddressChangePage",
    components: {
        BreadcrumbList
    },
    setup() {
        const data = reactive(new MailAddress());
        const { loading } = useLoad();
        const router = useRouter();
        const hasAddress = computed(() => myPageStore.personal.hasMailAddress);
        const valid = reactive(new Validator(data, constraints));
        // 画面名取得
        const pageName = commonStore.pageName(hasAddress.value ? PageID.mailaddressChange : PageID.mailaddressConfig);
        const submit = async () => {
            valid.reset();
            if (valid.error || !data.mailAddress) {
                MsgBox.error("入力に不備があります。<br/>確認してください。");
                return;
            }
            try {
                Loading.show();
                await store.update(data);
                router.push({ name: "mailaddress-check" });
            }
            catch (ex) {
                if (!valid.handle(ex)) {
                    log.error("MailAddressChangePage", ex);
                    MsgBox.error(ex.message);
                }
            }
            finally {
                Loading.hide();
            }
        };
        if (!hasAddress.value) {
            MsgBox.info(commonStore.messages.PI0013);
        }
        return {
            ...toRefs(store),
            ...useLoad(),
            loading,
            data,
            valid,
            submit,
            hasAddress,
            pageName,
            PageID
        };
    }
});
